import type { RouteLocationRaw } from 'vue-router'
import { buildRouteWithListScope } from '@/shared/scope/listScope'
import { isResellerContextPath } from '@/shared/constants/resellerContext'

function normalizePath(path: string): string {
  return path.split('?')[0]?.replace(/\/$/, '') || '/'
}

export function parseResellerQueryParam(value: unknown): string | number | undefined {
  if (typeof value === 'string' && value.trim().length > 0) return value
  if (Array.isArray(value) && typeof value[0] === 'string' && value[0].trim().length > 0) {
    return value[0]
  }
  return undefined
}

/** Append reseller scope to navigation targets. Prefer buildRouteWithListScopeFromRoute. */
export function buildRouteWithResellerContext(
  to: RouteLocationRaw,
  scope: { accountId?: string | number; resellerId?: string | number }
): RouteLocationRaw {
  if (typeof to === 'string' && !isResellerContextPath(normalizePath(to))) return to
  return buildRouteWithListScope(to, scope)
}
